export const LOCALES = {
  en: "en",
  pl: "pl",
};

export const AVAILABLE_LOCALES = Object.values(LOCALES);
export const DEFAULT_LOCALE = LOCALES.en;
export const FALLBACK_LOCALE = LOCALES.en;
